import { render, staticRenderFns } from "./ConfirmActionModal.vue?vue&type=template&id=585dd761&scoped=true"
import script from "./ConfirmActionModal.vue?vue&type=script&lang=js"
export * from "./ConfirmActionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585dd761",
  null
  
)

export default component.exports